import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";

const TiresInspection = ({
  onNext,
  onBack,
  MaintainanceData,
  BookingData,
  setCount,
  ImageLink,
  cardata,
  FromComeData,
}) => {
  const [tirePressure, setTirePressure] = useState({
    frontRight: "",
    frontLeft: "",
    rearLeft: "",
    rearRight: "",
  });

  const [tireTread, setTireTread] = useState({
    frontRight: "",
    frontLeft: "",
    rearLeft: "",
    rearRight: "",
  });
  const [tireNotes, setTireNotes] = useState({
    frontRight: "",
    frontLeft: "",
    rearLeft: "",
    rearRight: "",
  });

  const [tireAction, setTireAction] = useState("");
  const [replacedTire, setReplacedTire] = useState([]); // Changed to array
  const [tireActionNote, setTireActionNote] = useState("");

  const [error, setError] = useState({
    pressure: "",
    tread: "",
    action: "",
    replaced: "",
    note: "",
  });

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  useEffect(() => {
    setTirePressure({
      frontRight: MaintainanceData.tire_air_front_right,
      frontLeft: MaintainanceData.tire_air_front_left,
      rearLeft: MaintainanceData.tire_air_rear_left,
      rearRight: MaintainanceData.tire_air_rear_right,
    });

    setTireTread({
      frontRight: MaintainanceData.tire_trade_front_right,
      frontLeft: MaintainanceData.tire_trade_front_left,
      rearLeft: MaintainanceData.tire_trade_rear_left,
      rearRight: MaintainanceData.tire_trade_rear_right,
    });

    setTireNotes({
      frontRight: MaintainanceData.tire_notes_front_right || "",
      frontLeft: MaintainanceData.tire_notes_front_left || "",
      rearLeft: MaintainanceData.tire_notes_rear_left || "",
      rearRight: MaintainanceData.tire_notes_rear_right || "",
    });

    setTireAction(MaintainanceData.tire);
    setTireActionNote(MaintainanceData.tire_action_note || "");

    setReplacedTire(
      MaintainanceData.replace_tire
        ? MaintainanceData.replace_tire.split(",").map((t) => t.trim())
        : []
    );
  }, [MaintainanceData]);

  const handleTirePressureChange = (position, value) => {
    const updatedPressure = { ...tirePressure, [position]: value };
    setTirePressure(updatedPressure);
    if (
      updatedPressure.frontRight &&
      updatedPressure.frontLeft &&
      updatedPressure.rearLeft &&
      updatedPressure.rearRight
    ) {
      setError((prev) => ({ ...prev, pressure: "" }));
    }
  };

  const handleTireTreadChange = (position, value) => {
    const updatedTread = { ...tireTread, [position]: value };
    setTireTread(updatedTread);

    // Only clear note when changing away from "Change Required"
    if (value !== "Change Required") {
      setTireNotes((prev) => ({
        ...prev,
        [position]: "",
      }));
    }

    // Clear tread error if all filled
    if (
      updatedTread.frontRight &&
      updatedTread.frontLeft &&
      updatedTread.rearLeft &&
      updatedTread.rearRight
    ) {
      setError((prev) => ({ ...prev, tread: "" }));
    }
  };

  const handleReplacedTireChange = (position) => {
    let updated = [...replacedTire];

    if (position === "No") {
      // If "No" is selected, deselect all others and keep only "No"
      if (updated.includes("No")) {
        updated = []; // Deselect "No"
      } else {
        updated = ["No"]; // Select only "No"
      }
    } else {
      // If any other position is selected
      updated = updated.filter((item) => item !== "No"); // Remove "No" if present

      if (updated.includes(position)) {
        updated = updated.filter((item) => item !== position); // Deselect if already selected
      } else {
        updated.push(position); // Select new position
      }
    }

    setReplacedTire(updated);
    setError((prev) => ({ ...prev, replaced: "" }));
  };

  const handleTreadNoteChange = (position, note) => {
    setTireNotes((prev) => ({
      ...prev,
      [position]: note,
    }));
  };
  const handleTireActionChange = (action) => {
    setTireAction(action);
    setError((prev) => ({ ...prev, action: "" }));
    if (action !== "Change Next Time") {
      setTireActionNote("");
    }
  };

  //console.log("Tire Notes:", tireNotes);
  //console.log("Tire Action Note:", tireActionNote);
  const validateFields = () => {
    let isValid = true;

    const newErrors = {
      pressure: "",
      tread: "",
      action: "",
      replaced: "",
      note: "",
    };

    // ✅ Tire Pressure Validation
    const missingPressure = [];
    if (!tirePressure.frontRight) missingPressure.push("Right Front");
    if (!tirePressure.frontLeft) missingPressure.push("Front Left");
    if (!tirePressure.rearLeft) missingPressure.push("Rear Left");
    if (!tirePressure.rearRight) missingPressure.push("Rear Right");

    if (missingPressure.length > 0) {
      newErrors.pressure = `Please fill: ${missingPressure.join(", ")}`;
      isValid = false;
    }

    // ✅ Tire Tread Validation
    const missingTread = [];
    if (!tireTread.frontRight) missingTread.push("Front Right");
    if (!tireTread.frontLeft) missingTread.push("Front Left");
    if (!tireTread.rearLeft) missingTread.push("Rear Left");
    if (!tireTread.rearRight) missingTread.push("Rear Right");

    if (missingTread.length > 0) {
      newErrors.tread = `Please fill: ${missingTread.join(", ")}`;
      isValid = false;
    }

    // ✅ Note validation for "Change Required"
    const noteRequiredFor = [];
    ["frontRight", "frontLeft", "rearLeft", "rearRight"].forEach((position) => {
      if (
        tireTread[position] === "Change Required" &&
        (!tireNotes[position] || tireNotes[position].trim() === "")
      ) {
        const label = position
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (c) => c.toUpperCase());
        noteRequiredFor.push(label);
      }
    });

    if (noteRequiredFor.length > 0) {
      newErrors.tread = `Note is required for: ${noteRequiredFor.join(", ")}`;
      isValid = false;
    }

    // ✅ Tire Action validation
    if (!tireAction) {
      newErrors.action = "Please select a tire action";
      isValid = false;
    }

    // ✅ Note validation if action is "Change Next Time"
    if (
      tireAction === "Change Next Time" &&
      (!tireActionNote || tireActionNote.trim() === "")
    ) {
      newErrors.action = "Note is required for 'Change Next Time'";
      isValid = false;
    }

    // ✅ Replaced Tires Validation
    if (replacedTire.length === 0) {
      newErrors.replaced = "Please select at least one replaced tire";
      isValid = false;
    }

    // ✅ Final Error State
    setError(newErrors);

    return isValid;
  };
  //console.log("tirePressure", tirePressure);
  const handleNext = async () => {
    if (validateFields()) {
      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      // Tire pressure data
      fd.append("tire_air_front_right", tirePressure.frontRight);
      fd.append("tire_air_front_left", tirePressure.frontLeft);
      fd.append("tire_air_rear_left", tirePressure.rearLeft);
      fd.append("tire_air_rear_right", tirePressure.rearRight);

      // Tire tread data - conditional append based on "Change Required"
      fd.append(
        "tire_trade_front_right",
        tireTread.frontRight === "Change Required"
          ? tireNotes.frontRight
          : tireTread.frontRight
      );
      fd.append(
        "tire_trade_front_left",
        tireTread.frontLeft === "Change Required"
          ? tireNotes.frontLeft
          : tireTread.frontLeft
      );
      fd.append(
        "tire_trade_rear_left",
        tireTread.rearLeft === "Change Required"
          ? tireNotes.rearLeft
          : tireTread.rearLeft
      );
      fd.append(
        "tire_trade_rear_right",
        tireTread.rearRight === "Change Required"
          ? tireNotes.rearRight
          : tireTread.rearRight
      );
      fd.append(
        "tire",
        tireAction === "Change Next Time" ? tireActionNote : tireAction
      );
      fd.append("replace_tire", replacedTire.join(","));
      fd.append("step_for_maintenance", 3);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);

      setshowLoaderAdmin(true);

      try {
        const Response = await server_post_data(maintainance_car_data, fd);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          //console.log("Success - Replaced Tires:", replacedTire);
          onNext();
          setCount(4);
        }
      } catch (error) {
        console.error("Network error:", error);
        handleError("network");
      } finally {
        setshowLoaderAdmin(false);
      }
    }
  };

  return (
    <>
      <div className="tires-inspection-container">
        <h3 className="section-title text-primary">
          Tires Inspection | <span>Tire Air Pressure (32-35 PSI)</span>{" "}
          <span className="mandory_field">*</span>
        </h3>
        {error.pressure && <span className="error-text">{error.pressure}</span>}
        <div className="section">
          <div className="tire-pressure-grid">
            {[
              { label: "Right", key: "frontRight" },
              { label: "Front Left", key: "frontLeft" },
              { label: "Rear Left", key: "rearLeft" },
              { label: "Rear Right", key: "rearRight" },
            ].map(({ label, key }) => (
              <React.Fragment key={key}>
                <div className="position-label">{label}</div>
                <div className="btn-group" role="group">
                  {["> 35", "32-35", " < 32", "Leak"].map((value) => (
                    <button
                      key={value}
                      type="button"
                      className={`btn btn-outline-secondary ${
                        tirePressure[key] === value ? "active" : ""
                      }`}
                      onClick={() => handleTirePressureChange(key, value)}
                    >
                      {value}
                    </button>
                  ))}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="section mt-4">
          <h4 className="text-primary">
            Tire Tread Depth <span className="replceTxt"> | Tire Position</span>{" "}
            <span className="mandory_field">*</span>
          </h4>
          {error.tread && <span className="error-text">{error.tread}</span>}

          <div>
            {/**-----------------Front Right--------------- */}
            <div className="front_Right">
              <div className="light_left_right_containr">
                <div className="tail_light_left_section custum_min_width">
                  <label className="position-label">Front Right </label>
                </div>

                <div className="tail_light_right_section padding_none_class">
                  {["100%", "75%", "50%", "25%", "Change Required"].map(
                    (val) => (
                      <div className="col" key={val}>
                        <div className="btn-group" role="group">
                          <button
                            type="button"
                            className={`btn btn-outline-secondary ${
                              tireTread.frontRight === val ? "active" : ""
                            }`}
                            onClick={() =>
                              handleTireTreadChange("frontRight", val)
                            }
                          >
                            {val}
                          </button>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              {tireTread.frontRight == "Change Required" && (
                <div className="custum_min_width_note">
                  <label className="position-label">
                    Note<span className="error-text">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter notes here..."
                    maxLength={500}
                    onChange={(e) =>
                      handleTreadNoteChange("frontRight", e.target.value)
                    }
                  />
                </div>
              )}
            </div>

            {/**-----------------Front Left--------------- */}
            <div className="front_left mt-2">
              <div className="light_left_right_containr">
                <div className="tail_light_left_section custum_min_width">
                  <label className="position-label">Front Left</label>
                </div>

                <div className="tail_light_right_section padding_none_class">
                  {["100%", "75%", "50%", "25%", "Change Required"].map(
                    (val) => {
                      const currentValue = tireTread.frontLeft;
                      const validValues = ["100%", "75%", "50%", "25%"];
                      const shouldForceChangeRequired =
                        (!currentValue ||
                          !validValues.includes(currentValue)) &&
                        val === "Change Required";

                      const isActive =
                        currentValue === val || shouldForceChangeRequired;

                      return (
                        <div className="col" key={val}>
                          <div className="btn-group" role="group">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${
                                isActive ? "active" : ""
                              }`}
                              onClick={() =>
                                handleTireTreadChange("frontLeft", val)
                              }
                            >
                              {val}
                            </button>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              {tireTread.frontLeft == "Change Required" && (
                <div className="custum_min_width_note">
                  <label className="position-label">
                    Note<span className="error-text">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter notes here..."
                    maxLength={500}
                    value={tireNotes.frontLeft}
                    onChange={(e) =>
                      handleTreadNoteChange("frontLeft", e.target.value)
                    }
                  />
                </div>
              )}
            </div>

            {/**-----------------Rear Left--------------- */}
            <div className="rear_left mt-2">
              <div className="light_left_right_containr">
                <div className="tail_light_left_section custum_min_width">
                  <label className="position-label">Rear Left</label>
                </div>

                <div className="tail_light_right_section padding_none_class">
                  {["100%", "75%", "50%", "25%", "Change Required"].map(
                    (val) => {
                      const currentValue = tireTread.rearLeft;
                      const validValues = ["100%", "75%", "50%", "25%"];
                      const shouldForceChangeRequired =
                        (!currentValue ||
                          !validValues.includes(currentValue)) &&
                        val === "Change Required";

                      const isActive =
                        currentValue === val || shouldForceChangeRequired;

                      return (
                        <div className="col" key={val}>
                          <div className="btn-group" role="group">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${
                                isActive ? "active" : ""
                              }`}
                              onClick={() =>
                                handleTireTreadChange("rearLeft", val)
                              }
                            >
                              {val}
                            </button>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              {tireTread.rearLeft == "Change Required" && (
                <div className="custum_min_width_note">
                  <label className="position-label">
                    Note<span className="error-text">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter notes here..."
                    maxLength={500}
                    value={tireNotes.rearLeft}
                    onChange={(e) =>
                      handleTreadNoteChange("rearLeft", e.target.value)
                    }
                  />
                </div>
              )}
            </div>

            {/**-----------------Rear Right--------------- */}
            <div className="rear_right mt-2">
              <div className="light_left_right_containr">
                <div className="tail_light_left_section custum_min_width">
                  <label className="position-label">Rear Right</label>
                </div>

                <div className="tail_light_right_section padding_none_class">
                  {["100%", "75%", "50%", "25%", "Change Required"].map(
                    (val) => {
                      const currentValue = tireTread.rearRight;
                      const validValues = ["100%", "75%", "50%", "25%"];
                      const shouldForceChangeRequired =
                        (!currentValue ||
                          !validValues.includes(currentValue)) &&
                        val === "Change Required";

                      const isActive =
                        currentValue === val || shouldForceChangeRequired;

                      return (
                        <div className="col" key={val}>
                          <div className="btn-group" role="group">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${
                                isActive ? "active" : ""
                              }`}
                              onClick={() =>
                                handleTireTreadChange("rearRight", val)
                              }
                            >
                              {val}
                            </button>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              {tireTread.rearRight == "Change Required" && (
                <div className="custum_min_width_note">
                  <label className="position-label">
                    Note<span className="error-text">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter notes here..."
                    maxLength={500}
                    value={tireNotes.rearRight}
                    onChange={(e) =>
                      handleTreadNoteChange("rearRight", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="section mt-4">
          <div className="row align-items-center">
            <div className="col-md-2">
              <h5 className="text-primary mb-0">
                Tire Actions: <span className="mandory_field">*</span>
              </h5>
              {error.action && (
                <span className="error-text">{error.action}</span>
              )}
            </div>
            <div className="col-md-10">
              <div
                className="btn-group w-100 d-flex newBtnsColumn"
                role="group"
              >
                {["Good", "Changed", "Change Next Time"].map((action) => {
                  const validActions = ["Good", "Changed", "Change Next Time"];
                  const shouldForceChange =
                    (!tireAction || !validActions.includes(tireAction)) &&
                    action === "Changed";

                  const isActive = tireAction === action || shouldForceChange;

                  return (
                    <button
                      key={action}
                      type="button"
                      className={`btn btn-outline-secondary ${
                        isActive ? "active" : ""
                      }`}
                      onClick={() => handleTireActionChange(action)}
                    >
                      {action}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          {!["Good", "Change"].includes(tireAction) && (
            <div className="custum_min_width_note">
              <label className="position-label">
                Note<span className="error-text">*</span>
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Enter notes here..."
                maxLength={500}
                value={tireActionNote}
                onChange={(e) => setTireActionNote(e.target.value)}
              />
            </div>
          )}
        </div>

        <div className="section mt-4">
          {error.replaced && (
            <span className="error-text">{error.replaced}</span>
          )}
          <div className="row align-items-center">
            <div className="col-md-2">
              <h5 className="mb-0 replceTxt">
                Replaced Tire: <span className="mandory_field">*</span>
              </h5>
            </div>
            <div className="col-md-10">
              <div className="btn-group w-100" role="group">
                {[
                  "Front Left",
                  "Front Right",
                  "Rear Left",
                  "Rear Right",
                  "No",
                ].map((position) => (
                  <button
                    key={position}
                    type="button"
                    className={`btn btn-outline-secondary ${
                      replacedTire.includes(position) ? "active" : ""
                    }`}
                    onClick={() => handleReplacedTireChange(position)}
                  >
                    {position}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default TiresInspection;
